import { jsx as _jsx } from "react/jsx-runtime";
import { useLexicalDeserializer } from '../hooks';
export const RichContentContainer = ({ initialValue, containerRef, ...props }) => {
    useLexicalDeserializer(initialValue);
    return _jsx("div", { ...props, ref: containerRef });
};
RichContentContainer.displayName = 'RichContentContainer';
